import defaultAttributes from '../defaultAttributes';

const AlignEndVertical = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '2', y: '4', width: '16', height: '6', rx: '2' }],
    ['rect', { x: '9', y: '14', width: '9', height: '6', rx: '2' }],
    ['path', { d: 'M22 22V2' }],
  ],
];

export default AlignEndVertical;
